import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Baby, Flame, Tv, Swords, Building2, GraduationCap, ArrowRight } from "lucide-react";

const MotionLink = motion(Link);

const JOURNEYS = [
  {
    icon: Baby,
    label: "Kids Classes",
    desc: "Ages 6–17 · Confidence + culture",
    to: "/kids",
    accent: "yellow",
  },
  {
    icon: Flame,
    label: "Adult Training",
    desc: "Weekly classes across all styles",
    to: "/training",
    accent: "yellow",
  },
  {
    icon: Tv,
    label: "Online Courses",
    desc: "On-demand · stream anywhere",
    to: "/online",
    accent: "purple",
  },
  {
    icon: Swords,
    label: "Events & Battles",
    desc: "Cyphers, battles & showcases",
    to: "/events",
    accent: "yellow",
  },
  {
    icon: Building2,
    label: "Schools & Organisations",
    desc: "Bespoke training on request",
    to: "/schools-organisations",
    accent: "purple",
  },
  {
    icon: GraduationCap,
    label: "BA Pathway",
    desc: "Level 2 → degree · launching soon",
    to: "/ba-pathway",
    accent: "purple",
  },
];

export const ChooseJourney = () => {
  return (
    <section
      id="journey"
      data-testid="journey-section"
      className="relative py-16 sm:py-20 bg-black border-b border-white/5"
    >
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(90,24,154,0.12),transparent_55%)]" />
      <div className="relative max-w-7xl mx-auto px-6 sm:px-8">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-8">
          <div>
            <div className="flex items-center gap-3 mb-3">
              <span className="h-px w-8 bg-brand-yellow" />
              <span className="text-[10px] font-bold uppercase tracking-[0.32em] text-brand-yellow">Choose Your Journey</span>
            </div>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl text-white tracking-wide">
              Where do you want to <span className="text-brand-yellow">start</span>?
            </h2>
          </div>
          <p className="text-sm text-zinc-400 max-w-sm md:text-right">
            Pick a lane — we'll guide you to the right programme.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 sm:gap-4">
          {JOURNEYS.map((j, i) => (
            <MotionLink
              key={j.label}
              to={j.to}
              data-testid={`journey-${j.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className={`group relative block p-4 sm:p-5 rounded-2xl bg-white/[0.03] border border-white/10 hover:border-${
                j.accent === "yellow" ? "brand-yellow" : "brand-purpleLight"
              }/60 hover:bg-white/[0.07] hover:-translate-y-1 transition-all cursor-pointer`}
            >
              <div
                className={`w-9 h-9 rounded-lg flex items-center justify-center mb-3 ${
                  j.accent === "yellow"
                    ? "bg-brand-yellow/10 border border-brand-yellow/30 group-hover:bg-brand-yellow"
                    : "bg-brand-purple/15 border border-brand-purpleLight/30 group-hover:bg-brand-purple"
                } transition-colors`}
              >
                <j.icon
                  size={16}
                  className={`${j.accent === "yellow" ? "text-brand-yellow group-hover:text-black" : "text-brand-purpleLight group-hover:text-white"} transition-colors`}
                />
              </div>
              <div className="font-display text-base sm:text-lg text-white tracking-wide leading-tight">
                {j.label}
              </div>
              <div className="text-[10px] uppercase tracking-[0.15em] text-zinc-500 mt-1 line-clamp-2">
                {j.desc}
              </div>
              <ArrowRight
                size={14}
                className="absolute top-4 right-4 text-zinc-600 group-hover:text-brand-yellow group-hover:translate-x-0.5 transition-all"
              />
            </MotionLink>
          ))}
        </div>
      </div>
    </section>
  );
};
